<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Marka</label>
            <v-validator :errors="errors" parameter="VehicleBrandId" :watch="brand">
                <v-select-list v-model="brand" label="Name" placeholder="Marka" :options="brands" img="Logo"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Model</label>
            <v-validator :errors="errors" parameter="VehicleBrandModelId" :watch="model">
                <v-select-list :disabled="!brand" v-model="model" placeholder="Model" label="Name" :options="models"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Seri</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" class="form-control" placeholder="Seri" v-model="value.Name">
            </v-validator>
        </div>
    </div>
</template>

<script>
import VehicleDefinitionsApi from '@/api/vehicle-definitions'
export default{
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return{
            brands:[],
            models:[],
        }
    },
    mounted(){
        this.getBrands()
    },
    watch:{
        brand(nevV,oldV){
            if(nevV != oldV){
                this.getModels()
                this.models = []
                this.model = null
            }
        }
    },
    methods:{
        getBrands(){
            VehicleDefinitionsApi.Brand.List()
            .then(res=>{
                this.brands = res.data.Data
            })
        },
        getModels(){
            if(this.brand?.Id){
                VehicleDefinitionsApi.BrandModel.ListByBrandId(this.brand.Id)
                .then(res=>{
                    this.models = res.data.Data
                })
            }
        },
    },
    computed:{
        brand:{
            get:function(){
                return this.brands.find(b=>b.Id==this.value.VehicleBrandId)
            },
            set:function(value){
                this.value.VehicleBrandId = value?.Id || this.value.VehicleBrandId
            }
        },
        model:{
            get:function(){
                return this.models.find(s=>s.Id==this.value.VehicleBrandModelId)
            },
            set:function(value){
                this.value.VehicleBrandModelId = value?.Id || this.value.VehicleBrandModelId
            }
        }
    },
}
</script>